import React from "react";
import AddIcon from "../UIComponents/AddIcon";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ShipManagementCard from "../components/ShipManagementCard";
import { getShipManagementList, getPaintCoating, getEquipmentMachinery, getStructureAndHull, getStores, getShipManagementDetail } from "../Actions/ShipManagementAPI";

class ShipManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchData: {
                Name: '',
                PageNumber: 1,
                PageSize: 25
            }
        }
        this.SearchData = this.SearchData.bind(this);
        this.ClearInput = this.ClearInput.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        this.props.dispatch({ type: 'SubBannerTitle', data: "Ship Management" });
        this.props.dispatch(getShipManagementList(this.state.searchData));
    }

    SearchData(Pgno) {
        const { dispatch } = this.props;
        this.state.searchData.PageNumber = Pgno;
        dispatch(getShipManagementList(this.state.searchData));
        this.props.dispatch({ type: 'pagenumber', data: this.state.searchData });
    }

    eyeclick(item) {
        const { dispatch, history } = this.props;
        this.setState({ showSidePane: true })
        dispatch({ type: "ShowSidePan", data: true });
        //  dispatch({ type: "ShipDetails", data: item });
        history.push(`/Home/Management/Ship/${item.shipId}`);
        dispatch(getShipManagementDetail(item.shipId));
        dispatch(getPaintCoating(item.shipId));
        dispatch(getEquipmentMachinery(item.shipId));
        dispatch(getStructureAndHull(item.shipId));
        dispatch(getStores(item.shipId));
        window.scrollTo(0, 0);
    }

    NewitemNav = () => {
        this.props.history.push("/Home/Management/ShipAdd");
        this.props.dispatch({ type: "GetPaintCoatingList", data: null });
        this.props.dispatch({ type: "GetEquipmentMachineryList", data: null });
        this.props.dispatch({ type: "GetStructureHullList", data: null });
        this.props.dispatch({ type: "GetStoreList", data: null });
        this.props.dispatch({ type: "InventoryUploadSuccess", data: "" });
        this.props.dispatch({ type: "AttachmentUploadHKCSuccess", data: "" });
        this.props.dispatch({ type: "AttachmentUploadEUSSRSuccess", data: "" });
        this.props.dispatch({ type: "AttachmentUploadFullManualSuccess", data: "" });
        this.props.dispatch({ type: "AttachmentUploadFlagSOCSuccess", data: "" });
        this.props.dispatch({ type: "AttachmentUploadSuccess", data: "" });
        this.props.dispatch({ type: "AttachmentUploadIAPPSuccess", data: "" });
        this.props.dispatch({ type: "AttachmentUploadampSuccess", data: "" });
        this.props.dispatch({ type: "AttachmentUploadldafdSuccess", data: "" });
        this.props.dispatch({ type: "AttachmentUploadecSuccess", data: "" });
    };

    ShowSidePanel = () => {
        this.setState({ showSidePane: false })
        this.props.dispatch({ type: "ShowSidePan", data: false });
    }

    handleInputChange(e) {
        this.state.searchData.Name = e.target.value;
        if (e.target.value === "") {
            this.props.dispatch(getShipManagementList(this.state.searchData));
        }
        this.setState({});
    }

    ClearInput() {
        this.state.searchData.Name = "";
        this.props.dispatch(getShipManagementList(this.state.searchData));
        this.setState({});
    }

    hideSidePanel = () => {
        this.props.history.goBack();
        this.props.dispatch({ type: "ShowSidePan", data: false });
    }

    render() {
        const { ShipList } = this.props;
        return (
            <div className="full-height">
                <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-3"
                    onClick={() => this.hideSidePanel()}
                >
                    &larr; Back
                        </button>
                <div className="pt-3">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="panel-box">
                                        <div className="card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                                            <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                                                <h5 className="card-title m-2" style={{ color: "092a51" }}>
                                                    Ship Management
                                                </h5>
                                                <div className="m-1 flex" onClick={this.NewitemNav}>
                                                    <span className="card-title m-auto">Add</span><AddIcon />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="search-filter-box">
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <label className="form-label" >Ship Name</label><br></br>
                                                    <input className="form-control" type="text" name="shipname" value={this.state.searchData.Name} placeholder="Ship Name" onChange={e => this.handleInputChange(e)}></input>
                                                </div>
                                                <div className="col-lg-6">
                                                    <label></label><br></br>
                                                    <div className="form-group mt-3 search-btn-col" style={{ textAlign: "end" }}>
                                                        <button
                                                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                            type="submit" onClick={() => this.SearchData(1)}>Search
                                                        </button>
                                                        <button
                                                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                            type="button" onClick={() => this.ClearInput()}> {" "} Clear{" "}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {ShipList ?
                                <ShipManagementCard
                                    arraylist={ShipList.data}
                                    pageSize={ShipList.pagination.pageSize}
                                    currentPage={ShipList.pagination.currentPage}
                                    totalRecords={ShipList.pagination.totalcount ? ShipList.pagination.totalcount : 0}
                                    setUpdatedState={(value) => this.SearchData(value)}
                                    eyeclick={(item) => this.eyeclick(item)}
                                />
                                : ''}
                        </div>
                    </div>
                </div>
            </div >
        )
    }
    renderCard = () => [

    ]
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
        showSidePane: state.SidePanReducer.sidePan || false,
        ShipList: state.MasterScreenReducer.ShipList
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ShipManagement));